/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Restore.css';
import Calendar from './../../components/Calendar'
import RestoreArticle from './../../components/RestoreArt'
import moment from 'moment'


let list=[
  '微信',
  '微博',
  '知乎',
  '今日头条',
  '悟空问答'
]


class Restore extends React.Component {
  constructor(){
    super()
    this.state={
      time:null,
      active:0,
      isCalendarCon:false,
      isShow:false,
      selectTime: null,
      
    }
    this.changeSelecPeriod = this.changeSelecPeriod.bind(this)
    this.enCalendarCon=this.enCalendarCon.bind(this)
    this.ovCalendarCon=this.ovCalendarCon.bind(this)
    this.openCalendar = this.openCalendar.bind(this)
    this.closeCalendar = this.closeCalendar.bind(this)
  }

  componentWillMount() {
    // console.log(moment().format('a'))
    if(this.state.selectTime==null){
			if(moment().format('a')=='pm'){
        this.setState({selectTime:`${moment().subtract(1,'days').format('YYYY-MM-DD')}`})
      }else{
        this.setState({selectTime:`${moment().subtract(2,'days').format('YYYY-MM-DD')}`})
      }
		}
  }

  enCalendarCon=()=>{
    this.setState({
        isCalendarCon:true
    })
  }
  ovCalendarCon=()=>{
      this.setState({
          isCalendarCon:false
      })
  }
  openCalendar() {
      this.setState({
          isShow: !this.state.isShow,
          // selectTime:ss
      })
  }
  changeSelecPeriod = (index,nextTime) => {
      
     
     
      

      
  }
  closeCalendar(ss) {
      this.setState({
          isShow: false,
          selectTime: ss
      })
      this.changeSelecPeriod(this.state.periodIndex,ss)
  }

  render() {
    const {active,time,isCalendarCon,selectTime}=this.state

    
    return (
      <div className={s.root}>
        <ul className={s.listUl}>
          {list.map((item,i)=>
            <li key={i} onClick={()=>this.setState({active:i})} className={active==i?s.ac:null} >{item}</li>
          )}
        </ul>
        <div className={s.timeItem} onBlur={()=>!isCalendarCon?this.setState({isShow:false}):null}  tabIndex='0'>
            <span className={s.timeInfoTxt}>当前时间：</span>
            <div className={s.month} onClick={this.openCalendar}>
                <i className={s.monthIcon}></i>
                <span className={s.monthTxt} >{selectTime}</span>
                
            </div>
            <Calendar  isShow={this.state.isShow} close={this.closeCalendar} cycle='日榜'
                en={this.enCalendarCon}   ov={this.ovCalendarCon}
            />
            
        </div>
        <div className={s.restoreArt}>
          <RestoreArticle time={selectTime} from={active} />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Restore);



// WEBPACK FOOTER //
// src/routes/restore/Restore.js